var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.svgRef = React.createRef();
        return _this;
    }
    Icon.prototype.render = function () {
        return (React.createElement("span", { "flow-id": this.props.flowId, className: this.getClasses('cg3-icon') },
            React.createElement("svg", { ref: this.svgRef, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": this.props.isDecorativeOnly, focusable: "false", role: this.props.srRole, width: "16", height: "16", className: this.props.isSpin ? 'cg3-icon-spin ' : '' },
                this.props.srTitle ? React.createElement("title", null, this.props.srTitle) : null,
                this.props.name ? React.createElement("use", { href: this.getIconUrl() }) : null,
                !this.props.name ? (React.createElement(React.Fragment, null, this.props.children)) : null)));
    };
    Icon.prototype.getSvgElement = function () {
        return this.svgRef.current;
    };
    Icon.prototype.getIconName = function () {
        return this.props.name;
    };
    Icon.prototype.getIconUrl = function () {
        return "#" + this.getIconName();
    };
    Icon.prototype.validateIcon = function () {
        var svgElement = this.getSvgElement();
        var iconName = this.getIconName();
        if (!iconName || !(svgElement === null || svgElement === void 0 ? void 0 : svgElement.isConnected)) {
            return;
        }
        var iconConstructor = this.constructor;
        var checkSpriteElement = function () {
            var iconSpriteElements = svgElement.ownerDocument.querySelectorAll("#".concat(iconName));
            if (iconSpriteElements.length === 0) {
                console.error("Icon \"".concat(iconName, "\" does not exist. Did you forget to add sprite for this icon?"));
            }
            if (iconSpriteElements.length > 1 && iconConstructor.warnings) {
                console.warn("Icon \"".concat(iconName, "\" is not unique. You should not include the same sprite more than once."));
            }
        };
        if (svgElement.ownerDocument.readyState === 'loading') {
            svgElement.ownerDocument.addEventListener('DOMContentLoaded', checkSpriteElement);
        }
        else {
            checkSpriteElement();
        }
    };
    Icon.prototype.cg_change = function (prevProps) {
        if (prevProps.name !== this.props.name) {
            this.validateIcon();
        }
    };
    Icon.prototype.getClasses = function (base) {
        return (base + ' ' + this.props.flowClass).trim() + ' ';
    };
    Icon.prototype.componentDidMount = function () {
        this.validateIcon();
    };
    Icon.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    Icon.defaultProps = {
        name: '',
        srRole: 'img',
        isSpin: false,
        isDecorativeOnly: true,
        flowId: 'icon',
        flowClass: '',
    };
    Icon.displayName = 'Icon';
    Icon.warnings = true;
    return Icon;
}(React.Component));
export { Icon };
